import React from 'react';
import { Icons } from './Icons';

const Toast = ({ type = 'success', message }) => {
  if (!message) return null;
  const icon = type === 'success' ? <Icons.Check className="w-4 h-4 text-green-400" /> : <Icons.Warning className="w-4 h-4 text-red-400" />;
  return (
    <div className="toast">
      {icon}
      <span className="text-sm">{message}</span>
    </div>
  );
};

export default Toast;